import icPc from '../assets/image/pc.png';
import icSimulation from '../assets/image/simulation3d.png';
import icLogo from '../assets/image/logo.png';
import icLogoKdec from '../assets/image/logo-KEDC.png';
import icLogoHColor from '../assets/image/Kawa_Dessin-H-Color.png';
import icLogoWhite from '../assets/image/Kawa_Dessin_White.png';
import icBien from '../assets/image/img_bien.jpg';
import logoStancer from '../assets/image/logo_stancer.png';
import logoGooglePay from '../assets/image/googlePay.png';
import logoVisa from '../assets/image/visa.png';
import logoMasterCard from '../assets/image/mastercard.png';
import imagePay from '../assets/image/payment.jpg';
const Images = {
    icPc: icPc, 
    icSimulation: icSimulation,
    icLogo: icLogo,
    icLogoKdec: icLogoKdec,
    icLogoHColor: icLogoHColor,
    icLogoWhite: icLogoWhite,
    icBien: icBien,
    logoGooglePay : logoGooglePay,
    logoStancer : logoStancer,
    logoVisa : logoVisa,
    logoMasterCard : logoMasterCard,
    imagePay : imagePay,
}
export default Images